var a=Math.max,t=Math.min,h=Math.round;export{a as max,t as min,h as round};
//# sourceMappingURL=math.js.map
